export default {"src":"/_next/static/media/NEAR.e0d4a28e.svg","height":27,"width":110,"blurWidth":0,"blurHeight":0};